"use client";

import {
  AnimatePresence,
  motion,
  useIsPresent,
  useReducedMotion,
} from "framer-motion";
import type { HeaderMotion } from "./header-motion";

/** The framer-motion old websites keep in the header and its menu, in one module so those files import no framer. */
export const legacyHeaderMotion = {
  motion: { div: motion.div },
  AnimatePresence,
  useIsPresent,
  useReducedMotion,
} as unknown as HeaderMotion;
